<template>
  <div class="wrapper" id="app">
    <CardForm
      :form-data="formData"
      @submit-card="submitCard"
    />
  </div>
</template>

<script>
import user from "@/api/user";
import payment from '@/api/payment'
import CardForm from '@/components/cardui/CardForm'
export default {
  name: 'app',
  components: {
    CardForm
  },
  data () {
    return {
      userData: {
        companyname: "",
        membercode: "",
        user: ""
      },
      formData: {
        clientCode: '',
        cardName: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: '',
        cardCurrency: '',
        cardAmount: 0,
        cardCompany: '',
        customerref: '',
        cardBackbutton: true
      }
    }
  },
  methods: {
    getUser() {
      user.getUser().then(res => {
        if (res && res["result"]) {
          this.userData = res["data"];
          this.assignCompanyCode();
        }
      });
    },
    submitCard(formData, mainCardNumber){
      let loading = this.$loading({
        lock: true,
        text: "Submitting...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      payment.makeMoto({
        cardnumber: mainCardNumber,
        cardType: formData.cardType,
        cardName: formData.cardName,
        cardMonth: formData.cardMonth,
        cardYear: formData.cardYear,
        cardCVV: formData.cardCvv,
        amount: formData.cardAmount,
        currency: formData.cardCurrency,
        clientCode: formData.clientCode,
        customerref: formData.customerref
      }).then((response) => {
        loading.close()
        if (response.result) {
          this.$router.push({ name: "PaymentSuccess", params: response.data });
        } else {
          loading.close()
          this.$message({
            message: response.message.error +  '' + response.message.code,
            type: "error",
            duration: 4 * 1000
          });
        }
      }).catch((error) => {
        loading.close()
        console.log(error)
      });
    },
    assignCompanyCode() {
      if(this.userData && this.userData.customercode) {
        this.formData.clientCode = this.userData.customercode;
      }
    }

  },
  created(){
    this.getUser();
  }
}
</script>

<style lang="scss">
@import './src/assets/css/cardui/style.scss';
</style>